import React, { useEffect, useState } from 'react';
import { getUserByUserId } from '../../services/authService';
import { useNavigate } from 'react-router-dom'; // Assuming react-router is used
import { encodeId } from '../../utills/idUtils';
import FancyLoader from '../../hooks/FancyLoder';

const ParticipantCard = ({ participant }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userId = participant.user_id;
                const fetchedUser = await getUserByUserId(userId);
                setUser(fetchedUser);


            } catch (err) {
                console.error("Error fetching user:", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [participant.user_id, participant.created_by_user, participant.status]); // Refetch if any relevant value changes

    if (loading) return <div><FancyLoader/>.</div>;
    if (error) return <div>Error loading user: {error.message}</div>;

    const handleCompleteNowClick = () => {
        if (participant.status === 'Pending' && user.user_id === participant.created_by_user) {
            const encodedId = encodeId(participant.assessment_id);

            navigate(`/self-asmt/${encodedId}`); // Navigate to self-asnt route
        }
    };

    return (
        <div className="flex items-center bg-blue-100 p-4 rounded-lg mb-4 w-full md:w-5/12">
       <div 
      style={{
        backgroundColor: '#38A169',  // Green background
        color: 'white',              // White text
        width: '40px',               // Set the width
        height: '40px',              // Set the height
        borderRadius: '50%',         // Round the corners
        display: 'flex',             // Flexbox to center content
        justifyContent: 'center',    // Center horizontally
        alignItems: 'center',       // Center vertically
        fontSize: '15px',            // Adjust font size
        fontWeight: 'bold',          // Make the letter bold
        textTransform: 'uppercase', // Ensure the letter is uppercase
        textAlign: 'center',        // Center text horizontally
        lineHeight: '40px',  
        margin:'8px'        // Align text vertically
      }}

    >
      {user.first_name.charAt(0).toUpperCase()}
    </div>

            <div className="lg:flex justify-between items-start gap-6">

                <div className='flex flex-col'>
                    <span className="font-semibold">
                        <span className="text-gray-500">{user.first_name}</span>
                    </span>
                    <span className="text-gray-500 text-xs lg:text-sm">{(user.user_name.slice(0, 30))}</span>
                </div>

                {participant.status === 'Pending' && participant.user_id === participant.created_by_user && (
                    <div className="text-center my-2 ml-auto font-semibold cursor-pointer text-blue-600 complete-now-animation" onClick={handleCompleteNowClick}>
                        Complete Now
                    </div>
                )}
                {participant.status === 'Completed' && participant.user_id === participant.created_by_user && (
                    <div className="text-center ml-auto font-semibold cursor-pointer text-blue-600 complete-now-animation" >
                        Me
                    </div>
                )}
                {/* {participant.user_id !== participant.created_by_user && (
                    ""
                    <div className="ml-auto font-semibold cursor-pointer">Remind</div>
                )} */}
            </div>





        </div>
    );
};

export default ParticipantCard;
